import React, { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import parseDateTime from "~/utils/parseDateTime"
import { ACTIVE_DATE_TYPE_NO_EXPIRATION, ActiveDatesType } from "~/constants/coupons"
import CouponsDatePicker from "~/components/Admin/Settings/Coupons/CouponsModalContent/CouponsDatePicker"

const CouponsActiveDates = ({
  activeDateType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  startDateError,
  endDateError,
  labels,
}: {
  activeDateType: ActiveDatesType
  startDate: string
  setStartDate: (v: string) => void
  endDate: string
  setEndDate: (v: string) => void
  startDateError: string | undefined
  endDateError: string | undefined
  labels?: Array<string>
}) => {
  const { camp } = useContext(AdminContext)
  const isStartDate = activeDateType === ACTIVE_DATE_TYPE_NO_EXPIRATION || !startDate?.length
  const isEndDate = activeDateType === ACTIVE_DATE_TYPE_NO_EXPIRATION || !endDate?.length

  return (
    <div className="flex items-center gap-2 w-full justify-center">
      <div className="flex flex-col">
        <label htmlFor="active-dates" className="block font-semibold text-md text-gray-900 mb-0.5">
          {labels && labels[0] ? labels[0] : "Start Date"}
        </label>
        <CouponsDatePicker
          isPickerImageHidden
          selectedDate={startDate}
          setSelectedDate={setStartDate}
          isStartDate={"start"}
          validUntilDate={parseDateTime(endDate, camp.timezone, { asMoment: true })}
          isNoExpiration={isStartDate}
          error={startDateError}
        />
      </div>
      <div className="w-2 rounded-lg h-0.5 bg-black mt-4"></div>
      <div className="flex flex-col">
        <label htmlFor="active-dates" className="block font-semibold text-md text-gray-900 mb-0.5">
          {labels && labels[1] ? labels[1] : "End Date"}
        </label>
        <CouponsDatePicker
          isPickerImageHidden
          selectedDate={endDate}
          setSelectedDate={setEndDate}
          isStartDate={"end"}
          validFromDate={parseDateTime(startDate, camp.timezone, { asMoment: true })}
          isNoExpiration={isEndDate}
          error={endDateError}
          initialMonth={endDate || startDate}
        />
      </div>
    </div>
  )
}

export default CouponsActiveDates
